module.exports = __webpack_public_path__ + "img/lupa.5eeba583.png";